export const listingConfigDrawer = {
  close: `Zamknij`,
  componentUnavailable: `Komponent niedostępny.`,
};
